import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import WithdrawalRow from "./withdrawalRow";
import {API} from "../../../../config";

const withdrawals = API.service('withdrawal');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorWithdrawals extends Component {
    state={
        wallet:[]
    };

    getWallet = () => {
        const app = this;
        withdrawals.find({query:{_account:this.props.investor._account}}).then(s=>{
            app.setState({
                wallet:s.data
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currency !== this.props.currency || prevProps.investor._id !== this.props.investor._id) {
            this.getWallet()
        }
    }

    componentDidMount() {
        this.getWallet()
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <table className={'w-full'}>
                    <tr className={classes.tableHead}>
                        <td>Date</td>
                        <td className={'text-center pl-2'}>Status</td>
                        <td className={'text-center pl-2'}>Amount</td>
                        <td className={'text-center pl-2'}>Account</td>
                    </tr>
                    {this.state.wallet.map((v,i)=>{
                        return (
                          <WithdrawalRow investor={this.props.investor} rowData={v}/>
                        )
                    })}
                </table>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorWithdrawals)));
